module.exports = __webpack_public_path__ + "static/media/AgencyZoomIcon.620941cc.svg";